import "../../../assets/scss/components/sections/home/work.scss";
import { Col, Container, Image, Row } from "react-bootstrap";
import Heading from "../../templates/heading";

import work1 from "../../../assets/images/home/work-1.svg";
import work2 from "../../../assets/images/home/work-2.svg";
import shape from "../../../assets/images/home/shape-1.svg";
import Btn from "../../templates/button";

const Work = () => {
  return (
    <div className="work-section" id="how-it-works">
      <Container>
        <div className="work">
          <Heading heading="How it works?" />
          <div className="content">
            <Row>
              <Col lg={5}>
                <div className="work-box">
                  <div className="numbering">1</div>
                  <div className="work-box-image work-box-image-1">
                    <Image src={work1} />
                  </div>
                  <h5 className="heading-5">Enter Job URL</h5>
                  <p className="paragraph-small-regular">
                    Input the job URL or description and click Create Resume
                  </p>
                </div>
              </Col>
              <Col lg={2}>
                <div className="shape-1">
                  <Image src={shape} />
                </div>
              </Col>
              <Col lg={5}>
                <div className="work-box">
                  <div className="numbering">2</div>
                  <div className="work-box-image work-box-image-2">
                    <Image src={work2} />
                  </div>
                  <h5 className="heading-5">Download Resume</h5>
                  <p className="paragraph-small-regular">
                    Get a tailored resume in 60 seconds. Download it in Word or
                    PDF format
                  </p>
                </div>
              </Col>
            </Row>
            <div className="watch-btn">
              <Btn
                class="btn-secondary"
                text="Get Started Free"
                handle={() => {
                  window.location.href = process.env.REACT_APP_APP_REGISTER_URL;
                }}
              />
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Work;
